// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080210/js/" + chunkId + "." + {"44":"d7babe55","225":"30510735","481":"77caaaf7","486":"18eea9dd","770":"f8b669ac"}[chunkId] + ".0.5836277972607679.chunk.js";
};